@if (!isSticky) {
  <div class="car-detail__header" [attr.data-custom-header]="true">
    <div class="car-detail__header-main">
      <div class="car-detail__header-content">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
  </div>
} @else {
  <div class="car-detail__header" [ngClass]="{ 'car-detail__header--sticky': isSticky }" [attr.data-custom-header]="true" [@slideFromTop]>
    <div class="car-detail__header-main">
      <div class="car-detail__header-content">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
  </div>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
